import { AppEnum, useCreateCheckoutSessionMutation } from '../generated/types';
import { enqueueSnackbar } from 'notistack';
import { t } from 'i18next';

export type UseCreateCheckoutParams = {
    cancelUrl: string;
    successUrl: string;
};
const useCreateCheckout = ({ cancelUrl, successUrl }: UseCreateCheckoutParams) => {
    const [createCheckoutSession, { loading }] = useCreateCheckoutSessionMutation();
    const createCheckout = () => {
        createCheckoutSession({
            variables: {
                input: {
                    cancelUrl: cancelUrl,
                    successUrl: successUrl,
                    sourceUrl: window.location.href,
                    app: AppEnum.Site,
                },
            },
            onCompleted(data) {
                if (data.createCheckoutSession.session?.url) {
                    window.location.href = data.createCheckoutSession.session?.url;
                }
            },
            onError(e) {
                console.log(e);
                enqueueSnackbar(t('account:payment.createCheckoutSession.failed'), { variant: 'error' });
            },
        });
    };

    return {
        createCheckout,
        loading,
    };
};
export default useCreateCheckout;
